import { levelContentData } from "../../components/Content/LevelContentData";
import { useLanguage } from "../../context/LanguageContext";
import { useEffect, useState } from "react";

export function useLevelContentData() {
  const { language } = useLanguage();
  const [translationData, setTranslationData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    import(`../translations/${language}-translateLevelContentData.js`)
      .then((module) => {
        if (isMounted) {
          setTranslationData(module.translateLevelContentData?.[language] || {});
        }
      })
      .catch(() =>
        import(`../translations/en-translateLevelContentData.js`).then((fallback) => {
          if (isMounted) {
            setTranslationData(fallback.translateLevelContentData?.en || {});
          }
        })
      );

    return () => {
      isMounted = false;
    };
  }, [language]);

  if (!translationData) return [];

  return (levelContentData ?? []).map((level) => {
    const {
      title,
      description = [],
      contentItems = [],
      videos = [],
      docs = [],
      utils = [],
    } = level;

    return {
      ...level,
      title: translationData.level?.[title] || title,
      description: Array.isArray(description)
        ? description.map((desc) => translationData.description?.[desc] || desc)
        : translationData.description?.[description] || description,
      contentItems: contentItems.map((key) => translationData.contentItems?.[key] || key),
      videos: videos.map((group) => ({
        ...group,
        list: (group?.list ?? []).map((key) => translationData.videos?.[key] || key),
      })),
      docs: docs.map((group) => ({
        ...group,
        list: (group?.list ?? []).map((key) => translationData.docs?.[key] || key),
      })),
      utils: utils.map((key) => translationData.utils?.[key] || key),
    };
  });
}






/* import { levelContentData } from "../../components/Content/LevelContentData";
import { useLanguage } from "../../context/LanguageContext";
import { translateLevelContentData } from "../translations/translateLevelContentData.js";
import { useTranslation } from "./translateHook.js";

export function useLevelContentData() {
  const t = useTranslation();

  return (levelContentData ?? []).map(level => {
    const {
      title,
      description = [],
      contentItems = [],
      videos = [],
      docs = [],
      utils = [],
    } = level;

    return {
      ...level,
      title: t(title),
      description: t(description),
      contentItems: contentItems.map(key => t(key)),

      videos: videos.map(group => ({
        ...group,
        // guard against a missing list field
        list: (group?.list ?? []).map(key => t(key)),
      })),

      docs: docs.map(group => ({
        ...group,
        list: (group?.list ?? []).map(key => t(key)),
      })),

      utils: utils.map(key => t(key)),
    };
  });
}
 */